export default __webpack_public_path__ + "static/media/item-image.4032b263.png";